// cart-free-gift.js
// Load order in theme.liquid: cart.js → cart-free-gift.js

console.log('[cart-free-gift] script loaded');

// ─── Section definitions ──────────────────────────────────────────────────────

function getCartPageSections() {
  if (document.getElementById('CartDrawer')) {
    return [
      { id: 'CartDrawer',       section: 'cart-drawer',        selector: '.drawer__inner' },
      { id: 'cart-icon-bubble', section: 'cart-icon-bubble',   selector: '.shopify-section' },
    ];
  }

  const mainItems  = document.getElementById('main-cart-items');
  const mainFooter = document.getElementById('main-cart-footer');
  if (!mainItems || !mainFooter) return [];

  return [
    { id: 'main-cart-items',       section: mainItems.dataset.id,    selector: '.js-contents' },
    { id: 'cart-icon-bubble',      section: 'cart-icon-bubble',      selector: '.shopify-section' },
    { id: 'cart-live-region-text', section: 'cart-live-region-text', selector: '.shopify-section' },
    { id: 'main-cart-footer',      section: mainFooter.dataset.id,   selector: '.js-contents' },
  ];
}

// ─── Render ───────────────────────────────────────────────────────────────────

window.renderCartSections = function (parsedState) {
  const cartEl = document.querySelector('cart-items') || document.querySelector('cart-drawer-items');
  if (!cartEl) return;

  const sections = getCartPageSections();

  if (!sections.length || !parsedState.sections) {
    if (cartEl.onCartUpdate) return cartEl.onCartUpdate();
    return;
  }

  const cartDrawerWrapper = document.querySelector('cart-drawer');
  const cartFooter        = document.getElementById('main-cart-footer');

  if (typeof parsedState.item_count !== 'undefined') {
    cartEl.classList.toggle('is-empty', parsedState.item_count === 0);
    if (cartFooter)        cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
    if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);
  }

  sections.forEach(({ id, section, selector }) => {
    const html = parsedState.sections[section];
    if (!html) return;
    const target = document.getElementById(id)?.querySelector(selector) || document.getElementById(id);
    if (!target) return;
    target.innerHTML =
      new DOMParser().parseFromString(html, 'text/html').querySelector(selector)?.innerHTML ?? html;
  });

  publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState });
};

// ─── Validate free gift ───────────────────────────────────────────────────────

window.validatingGift = false;
let revalidateQueued  = false;

window.validateGift = function () {
  // Lock immediately — before any async work — so the interval never double-fires
  if (window.validatingGift) { revalidateQueued = true; return; }

  const settings = window.cartFreeGiftSettings;
  if (!settings || !settings.giftItemId || !settings.giftThreshold) return;

  window.validatingGift = true;

  const giftVariantId = Number(settings.giftItemId);
  const threshold     = Number(settings.giftThreshold) * 100;

  // 1. Always fetch fresh cart data so cartObject is never stale
  fetch(routes.cart_url + '.js')
    .then((res) => res.json())
    .then((cartData) => {
      window.cartObject = cartData;

      const sections        = getCartPageSections();
      const sectionsPayload = sections.length
        ? { sections: sections.map((s) => s.section), sections_url: window.location.pathname }
        : {};

      // Find all gift lines — more than one means a duplicate slipped through
      const giftLines = cartData.items.reduce((acc, item, i) => {
        if (item.variant_id === giftVariantId && item.properties?._isFreeGift === 'true') acc.push(i);
        return acc;
      }, []);

      // Duplicate guard: force quantity back to 1 if somehow > 1 was added
      if (giftLines.length > 1) {
        console.warn('[cart-free-gift] duplicate gift detected — correcting');
        return fetch(routes.cart_change_url, {
          method:  'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body:    JSON.stringify(Object.assign({ id: giftVariantId, quantity: 1 }, sectionsPayload)),
        }).then((res) => res.json());
      }

      const lineIndex = giftLines[0] ?? -1;
      const giftItem  = lineIndex > -1 ? cartData.items[lineIndex] : null;
      const giftPrice = giftItem ? (giftItem.final_line_price || 0) : 0;
      const qualifies = (cartData.total_price - giftPrice) >= threshold;

      console.log('[cart-free-gift] qualifies:', qualifies, '| giftItem:', giftItem);

      // 2. Steady state — nothing to do
      if ((qualifies && giftItem) || (!qualifies && !giftItem)) {
        console.log('[cart-free-gift] steady state');
        return null;
      }

      // 3. Build payload and fire the right action
      const isAdding = qualifies && !giftItem;
      const url      = isAdding ? routes.cart_add_url : routes.cart_change_url;
      const body     = isAdding
        ? Object.assign({ id: giftVariantId, quantity: 1, properties: { _isFreeGift: 'true' } }, sectionsPayload)
        : Object.assign({ line: lineIndex + 1, quantity: 0 }, sectionsPayload);

      console.log('[cart-free-gift]', isAdding ? 'ADD' : 'REMOVE', '→', body);

      return fetch(url, {
        method:  'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body:    JSON.stringify(body),
      }).then((res) => res.json());
    })
    // 4. Render if cart was changed
    .then((parsedState) => {
      if (!parsedState) return;
      window.cartObject = parsedState;
      window.renderCartSections(parsedState);
    })
    .catch((err) => console.error('[cart-free-gift] error:', err))
    .finally(() => {
      window.validatingGift = false;
      if (revalidateQueued) { revalidateQueued = false; window.validateGift(); }
    });
};

setInterval(function () {
  if (typeof window.validateGift === 'function') window.validateGift();
}, 2000);